import { registerDynamicIslandVariant } from "../../dynamicIsland.registry";
import DynamicIslandVehicleRealtimeContent from "./DynamicIslandVehicleRealtimeContent";
import DynamicIslandVehicleRealtimeMotionWrapper from "./DynamicIslandVehicleRealtimeMotionWrapper";
import {
    getVehicleRealtimeAnimationKey,
    hasVehicleRealtimeTextDelta,
} from "./vehicleRealtime.animation.tools";

/**
 * Registers the vehicle realtime variant with the Dynamic Island registry.
 * No generic `shell` — content uses {@link VehicleInfoChrome} for its own background.
 */
export function registerVehicleRealtimeVariant(): void {
    registerDynamicIslandVariant( {
        "kind":             "vehicleRealtime",
        "ContentComponent": DynamicIslandVehicleRealtimeContent,
        "animation":        {
            "getPayloadAnimationKey":    getVehicleRealtimeAnimationKey,
            "ContentMotionWrapper":      DynamicIslandVehicleRealtimeMotionWrapper,
            "shouldAnimateContentDelta": hasVehicleRealtimeTextDelta,
            "kindSwitchPriority":        1,
            "motionOverrides":           {
                "spring": {
                    "type":      "spring" as const,
                    "stiffness": 480,
                    "damping":   34,
                    "mass":      0.8,
                },
            },
        },
    } );
}
